import { createEl } from "@/client/utils/createEl";
import { radioButton, type RadioButtonVariants } from "./radio-button.css";

export interface RadioButtonOptions extends NonNullable<RadioButtonVariants> {
    name: string;
    value: string;
    checked?: boolean;
    disabled?: boolean;
    onChange?: (value: string) => void;
    ariaLabel?: string;
}

export const createRadioButton = (
    options: RadioButtonOptions,
    init?: (el: HTMLInputElement) => void,
): HTMLInputElement => {
    const className = radioButton({
        theme: options.theme,
    });

    return createEl("input", className, [], (el) => {
        el.type = "radio";
        el.name = options.name;
        el.value = options.value;
        el.checked = options.checked ?? false;
        el.disabled = options.disabled ?? false;
        if (options.ariaLabel !== undefined) {
            el.setAttribute("aria-label", options.ariaLabel);
        }
        if (options.onChange !== undefined) {
            el.addEventListener("change", () => {
                if (el.checked) {
                    options.onChange?.(el.value);
                }
            });
        }
        init?.(el);
    });
};
